import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleCreateTask(
  list: Identifiable<List>,
  data: Boundaries["createTask"]["success"],
): Identifiable<List> {
  const { task, list: target } = data;
  const isTargetList = target.uuid === list.uuid;

  return isTargetList
    ? { ...list, tasks: [...list.tasks, task] }
    : {
        ...list,
        subLists: list.subLists.map((subList) =>
          handleCreateTask(subList, data),
        ),
      };
}

export { handleCreateTask };
